import {
  languageBuilder
} from "./builder.js";
const anime_airing = {
  UNIT_SINGULAR: `sarja`,
  UNIT_PLURAL: `sarjat`,
  UNIT_SHORT: `Sarja`,
  SUBUNIT_SINGULAR: `jakso`,
  SUBUNIT_PLURAL: `jaksot`,
  SUBUNIT_PLURAL_PARTITIVE: `jaksoa`,
  SUBUNIT_SHORT: `Jakso`,
  SUBUNIT_SHORT_ELATIVE: `Jaksosta`,
  SUBUNIT_VERB_FUTURE: `ilmestyy`,
  SUBUNIT_VERB_PAST: `ilmestyi`
};
const anime_bluray = {
  UNIT_SINGULAR: `sarja`,
  UNIT_PLURAL: `sarjat`,
  UNIT_SHORT: `Sarja`,
  SUBUNIT_SINGULAR: `boksi`,
  SUBUNIT_PLURAL: `boksit`,
  SUBUNIT_PLURAL_PARTITIVE: `boksia`,
  SUBUNIT_SHORT: `Vol.`,
  SUBUNIT_SHORT_ELATIVE: `Vol.`,
  SUBUNIT_VERB_FUTURE: `julkaistaan`,
  SUBUNIT_VERB_PAST: `julkaistiin`
};
const manga_chapter = {
  UNIT_SINGULAR: `manga`,
  UNIT_PLURAL: `manga`,
  UNIT_SHORT: `Manga`,
  SUBUNIT_SINGULAR: `luku`,
  SUBUNIT_PLURAL: `luvut`,
  SUBUNIT_PLURAL_PARTITIVE: `lukua`,
  SUBUNIT_SHORT: `Luku`,
  SUBUNIT_SHORT_ELATIVE: `Luvusta`,
  SUBUNIT_VERB_FUTURE: `ilmestyy`,
  SUBUNIT_VERB_PAST: `ilmestyi`
};
const manga_volume = {
  UNIT_SINGULAR: `manga`,
  UNIT_PLURAL: `manga`,
  UNIT_SHORT: `Manga`,
  SUBUNIT_SINGULAR: `pokkari`,
  SUBUNIT_PLURAL: `pokkarit`,
  SUBUNIT_PLURAL_PARTITIVE: `pokkaria`,
  SUBUNIT_SHORT: `Vol.`,
  SUBUNIT_SHORT_ELATIVE: `Vol.`,
  SUBUNIT_VERB_FUTURE: `julkaistaan`,
  SUBUNIT_VERB_PAST: `julkaistiin`
};
const strings = {
  ALL_COMPLETE: `Kaikki projektit ovat valmiita!`,
  CONNECTION_ERROR: `Yhteysvirhe`,
  CONFIG_HEADER: `Asetukset`,
  WEBSITE_SETTINGS_HEADER: `Verkkosivun asetukset`,
  APP_URL: `Sovelluksen URL-osoite`,
  LINK_PAGE: `Mene sivulle`,
  PAGE_BGCOLOR: `Sivuston taustav\xE4ri`,
  NO_COLOR: `\xC4l\xE4 v\xE4lit\xE4 taustav\xE4rist\xE4`,
  RECOMMENDED_BGCOLOR: `Suositeltu taustav\xE4ri`,
  OVERRIDE_BGCOLOR: `Ohita suositus`,
  THEME_HEADER: `Teemavalinta`,
  THEME_LIGHT: `Vaalea`,
  THEME_DARK: `Tumma`,
  SIZE_HEADER: `Kokovalinta`,
  SIZE_SMALL: `Pieni (ei suositella)`,
  SIZE_NORMAL: `Keskikokoinen`,
  ACCENT_HEADER: `Korostusv\xE4ri`,
  ACCENT_RED: `Punainen`,
  ACCENT_YELLOW: `Keltainen`,
  ACCENT_GREEN: `Vihre\xE4`,
  ACCENT_BLUE: `Sininen`,
  ACCENT_INDIGO: `Indigonsininen`,
  ACCENT_PURPLE: `Violetti`,
  ACCENT_PINK: `Pinkki`,
  ACCENT_NONE: `Ei korostusta`,
  LANGUAGE_HEADER: `Kieli`,
  EMBED_HEADER: `Wordpress-upotuskoodi`,
  EMBED_DESCRIPTION: `Muuta iframen kokoa sivun latauduttua`,
  EMBED_SHOW: `N\xE4yt\xE4 upotuskoodi`,
  EMBED_HIDE: `Piilota upotuskoodi`,
  ALL_POSITIONS: `Kaikki ty\xF6teht\xE4v\xE4t`,
  EXAMPLE_ERROR: `T\xE4ss\xE4 on esimerkki virheilmoituksesta`,
  EXAMPLE_STATUS: `T\xE4ss\xE4 on esimerkki mahdollisesta statusviestist\xE4`,
  UNIT_JOINT_WITH: `Yhteisty\xF6ss\xE4: {0}`,
  UNIT_SHOW_LESS: `Piilota seuraava %SUBUNIT_SINGULAR%`,
  UNIT_SHOW_LESS_PLURAL: `Piilota muut %SUBUNIT_PLURAL%`,
  UNIT_SHOW_REMAINDER_SINGULAR: `N\xE4yt\xE4 seuraava %SUBUNIT_SINGULAR%...`,
  UNIT_SHOW_REMAINDER_PLURAL: `N\xE4yt\xE4 seuraavat {1} %SUBUNIT_PLURAL_PARTITIVE%...`,
  UNIT_UPDATED: `P\xE4ivitetty {2}`,
  SUBUNIT_NOT_PUBLISHED: `%SUBUNIT_SHORT% {0} %SUBUNIT_VERB_FUTURE% {1}`,
  SUBUNIT_WAS_PUBLISHED: `%SUBUNIT_SHORT% {0} %SUBUNIT_VERB_PAST% {1}`,
  SUBUNIT_TO_RELEASE: `%SUBUNIT_SHORT% {0} odottaa julkaisua`,
  SUBUNIT_IN_PROGRESS: `%SUBUNIT_SHORT_ELATIVE% {0} j\xE4ljell\xE4 {2}`,
  SUBUNIT_NO_PROGRESS: `(aloittamatta)`
};
import fi from "../../_snowpack/pkg/javascript-time-ago/locale/fi.json.proxy.js";
const lang = {
  locale: fi,
  strings
};
export default {
  anime_airing: languageBuilder(lang, anime_airing),
  anime_bluray: languageBuilder(lang, anime_bluray),
  manga_chapter: languageBuilder(lang, manga_chapter),
  manga_volume: languageBuilder(lang, manga_volume)
};
//# sourceMappingURL=fi.js.map
